import { render } from "./Spreadsheet.vue?vue&type=template&id=59fc1d8e&ts=true"
import script from "./Spreadsheet.vue?vue&type=script&lang=ts"
export * from "./Spreadsheet.vue?vue&type=script&lang=ts"

import "./Spreadsheet.vue?vue&type=style&index=0&id=59fc1d8e&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__